




























import { Component, Vue } from "vue-property-decorator";
import { Getter, Action, State, Mutation } from "vuex-class";
import OrderItem from "./OrderItem.vue";
import { Order } from "@foxone/api/src/models/defi";

@Component({
  components: {
    OrderItem
  }
})
class OrderList extends Vue {
  @State(state => state.defi.orders.hasNext) hasNext;

  @Getter("defi/orders/getGroupedOrders") groupedOrders;

  @Mutation("defi/orders/REMOVE_ORDERS") removeOrders;

  @Action("defi/orders/loadOrders") loadOrders;

  loading = false;

  get loadMoreDisabled() {
    return this.loading || !this.hasNext;
  }

  mounted() {
    this.loadData(true);
  }

  beforeDestroy() {
    this.removeOrders();
  }

  async loadData(reload) {
    if (this.loading) {
      return;
    }
    this.loading = true;
    await this.loadOrders({ reload });
    this.loading = false;
  }

  handleToOrder(order: Order) {
    this.$helper.toFusionPath(this, "defi", {
      name: "orders-id",
      params: { id: order.id }
    });
  }
}
export default OrderList;
